/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator';
import { Inject } from 'vue-di-container';

import contractTemplateService from '@/services/contractTemplateService';
import WithRender from './select-template.component.html';
import { moduleProxy } from '@/store';
import ConfirmComponent from '@/components/Shared/confirm.component.vue';
import contractCategoriesModel from '@/models/contractCategoriesModel';
import ContractTemplateModel from '@/models/contractTemplateModel';
import UserModel from '@/models/user';
import router from '@/router';
import UserService from '@/services/user';

@WithRender
@Component({
  components: {
    ConfirmComponent
  },
  diProvide: [
    contractTemplateService,
    UserService
  ],
})
export default class SelectTemplateComponent extends Vue {
  @Inject(contractTemplateService) public contractTemplateService!: contractTemplateService;
  @Inject(UserService) public userService!: UserService;

  templates = {} as ContractTemplateModel[];
  contractCategories = {} as contractCategoriesModel[];
  currentUser = {} as UserModel;
  daysToCancelContract = 0;

  mounted() {
    // Check if the current route is related to the component.
    if (this.$route.name !== 'issueContract') {
      return;
    }

    moduleProxy.Stepper.hideStepper(true);
    this.getContractCategories();
    this.getCurrentUser();
    moduleProxy.Contract.clearContract();
  }

  getTemplatesByCategory(categoryId: number) {
    this.contractCategories.forEach(x => {
      if (x.id == categoryId) {
        x.isActive = true;
      } else {
        x.isActive = false
      }
    });

    this.contractTemplateService.getTemplates(categoryId).then(response => {
      this.templates = response.model;
      if (this.templates?.length > 0) {
        this.daysToCancelContract = this.templates[0].daysToCancelContract;
      }
    }).catch(() => {
    });
  }

  getContractCategories() {
    this.contractTemplateService.getContractCategories().then(response => {
      this.contractCategories = response.model.filter((x) => x.templatesCount);
      const id = this.contractCategories[0].id;
      this.getTemplatesByCategory(id);
    }).catch(() => {
    });
  }

  async selectTemplate(item: ContractTemplateModel) {
    if (
      await (this.$refs as any).confirm.open(
        "إقرار",
        ``,
        ``,
        {
          color: "#fff",
          width: 600,
          zIndex: 200,
          noconfirm: false,
          isIqrar: true
        }
      )
    ) {
      moduleProxy.Stepper.hideStepper(false);
      moduleProxy.Contract.setContractName(item.name);
      moduleProxy.Contract.setTemplateId(item.id);
      moduleProxy.Contract.setHasLawyer(item.hasLawyer);
      router.push({ name: "partners" });
    }

  }
  getCurrentUser() {
    this.userService.getUser().then(response => {
      this.currentUser = response;
      /* this.getNICUserInfo(this.currentUser);*/
    }).catch(error => {
      console.log('error: ', error)
    });
  }
}
